import { createContext } from 'react'

const PresentationAttendeesCtx = createContext()

export default PresentationAttendeesCtx
